const TmpMasterUpload = {
    TMP_MASTER_UPLOAD: "tmpMasterUpload",    
}

export default TmpMasterUpload